import React from 'react';
import PortletContext from './PortletContext';
import PortletHeader from './Header';
import PortletBody from './Body';

function Portlet({
  activeTab,
  handleTabClick,
  config,
  children,
  footer,
}) {
  return (
    <div className="kt-portlet kt-portlet--height-fluid">
      <PortletContext.Provider value={{ config }}>
        {config.noHeader ? null : (
          <PortletHeader
            tabs={config.tabs}
            activeTab={activeTab}
            handleTabClick={handleTabClick}
            title={config.title}
            actionsLabel={config.actionsLabel}
            actions={config.actions}
          />
        )}
        <PortletBody>
          {children}
        </PortletBody>
        {footer}
      </PortletContext.Provider>
    </div>
  );
}

export default Portlet;
